import { render, staticRenderFns } from "./VideoCategories.vue?vue&type=template&id=7f5e3c3f&scoped=true"
import script from "./VideoCategories.vue?vue&type=script&lang=js"
export * from "./VideoCategories.vue?vue&type=script&lang=js"
import style0 from "./VideoCategories.vue?vue&type=style&index=0&id=7f5e3c3f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5e3c3f",
  null
  
)

export default component.exports